import React, { useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useGiveFeedbackCompletedTasks } from '../state/hooks';
import useFeedbackFilters from '../../hooks/useFeedbackFilters';
import { getPaginationConfig } from './paginationUtils';
import FeedbackPageLayout from './FeedbackPageLayout';

function FeedbackHistory() {
  const [isShowMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;

  const {
    selectedYear,
    selectedState,
    selectedDocumentType,
    selectedSubject,
    selectedResponseType,
    sortItem,
    currentPage,
    filterConfig,
    handleFilterChange,
    setSortItem,
    handlePageChange,
  } = useFeedbackFilters();

  const {
    data: completedTasksResponse,
    isLoadingdata: isLoadingCompletedTasks,
    isFetching: isFetchingCompletedTasks,
  } = useGiveFeedbackCompletedTasks(filterConfig);

  const paginationConfig = getPaginationConfig(completedTasksResponse, filterConfig.size);

  const getFeedbackList = () => completedTasksResponse?.content || [];

  return (
    <FeedbackPageLayout
      isShowMenu={isShowMenu}
      setShowMenu={setShowMenu}
      selectedYear={selectedYear}
      selectedState={selectedState}
      selectedDocumentType={selectedDocumentType}
      selectedSubject={selectedSubject}
      selectedResponseType={selectedResponseType}
      sortItem={sortItem}
      handleFilterChange={handleFilterChange}
      setSortItem={setSortItem}
      feedbackList={getFeedbackList()}
      pathName={pathName}
      showPagination={true}
      paginationConfig={paginationConfig}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      isPaginationLoading={isLoadingCompletedTasks}
      isLoading={isLoadingCompletedTasks || isFetchingCompletedTasks}
    />
  );
}

export default FeedbackHistory;